import React from 'react';

interface ServiceCarIconProps {
  width?: string | number;
  height?: string | number;
  fill?: string;
}

const ServiceCarIcon = ({ width = '19', height = '19', fill = '#BEBEBE' }: ServiceCarIconProps) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill={fill}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.25 21.3846V18.3846H4.25V16.8846H19.75V18.3846H12.7499V21.3846H11.25ZM8.80765 11.7692C9.05252 11.7692 9.26117 11.683 9.4336 11.5106C9.60603 11.3382 9.69225 11.1295 9.69225 10.8846C9.69225 10.6398 9.60603 10.4311 9.4336 10.2587C9.26117 10.0862 9.05252 10 8.80765 10C8.56278 10 8.35413 10.0862 8.1817 10.2587C8.00927 10.4311 7.92305 10.6398 7.92305 10.8846C7.92305 11.1295 8.00927 11.3382 8.1817 11.5106C8.35413 11.683 8.56278 11.7692 8.80765 11.7692ZM15.1923 11.7692C15.4372 11.7692 15.6458 11.683 15.8183 11.5106C15.9907 11.3382 16.0769 11.1295 16.0769 10.8846C16.0769 10.6398 15.9907 10.4311 15.8183 10.2587C15.6458 10.0862 15.4372 10 15.1923 10C14.9474 10 14.7388 10.0862 14.5664 10.2587C14.3939 10.4311 14.3077 10.6398 14.3077 10.8846C14.3077 11.1295 14.3939 11.3382 14.5664 11.5106C14.7388 11.683 14.9474 11.7692 15.1923 11.7692ZM5.5 15.8846V9.06157L7.28705 3.88467H16.7096L18.5 9.06157V15.8846H17V13.8846H6.99997V15.8846H5.5ZM7.47687 7.88467H16.5231L15.65 5.38465H8.34998L7.47687 7.88467ZM6.99997 12.3846H17V9.38465H6.99997V12.3846Z"
          fill={fill}
        />
      </svg>
    </>
  );
};

export default ServiceCarIcon;
